import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../environments/environment";
import { AuthService } from "../authentication/auth.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  private userStatsApi: string =
    environment.apiBaseUrl + "/api/v1/partner/dashboard_stats";
  private dashboardChartsApi: string =
    environment.apiBaseUrl + "/api/v1/partner/dashboard/chart";
  private liveEnquiriesApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/live_enquiries";
  private EnquiryDetailsApiOld: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private VendorBidDetailsApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_bids/";
  private pastEnquiriesApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/past_enquiries";
  private vendorOrderItemApiOld: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private vendorOrderItemApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_bids/";
  private updateRfqCostApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_bids/";
  private rejectReasonsListApi: string =
    environment.apiBaseUrl + "/api/v1/rejection_reasons";
  private rejectLiveQuoteAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private submitLiveRfqApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private pendingPoListAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/pending_pos";
  private activePoListAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/active_pos";
  private pastPoListApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/past_pos";
  private poDetailsApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private acceptPoAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private rejectPoApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private userProfileApi: string =
    environment.apiBaseUrl + "/api/v1/partner/view_profile_detail";
  private machineListApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_owned_machines";
  private capabilitiesAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/view_capability_detail";
  private updatePasswordApi: string =
    environment.apiBaseUrl + "/api/v1/auth/change.password";
  private bankDetailsApi: string =
    environment.apiBaseUrl + "/api/v1/partner/view_bank_details";
  private updateBankDetailsApi: string =
    environment.apiBaseUrl + "/api/v1/partner/update_bank_detail";
  private updateTermsApi: string =
    environment.apiBaseUrl + "/api/v1/partner/update_terms_and_conditions";
  private raiseRequestApi: string =
    environment.apiBaseUrl + "/api/v1/partner/send_edit_request";
  private inventoryListApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private createDispatchAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private updateBatchAPi: string =
    environment.apiBaseUrl +
    "/api/v1/partner/vendor_orders/vendor_order_item_batch/";
  private updateBatchTimelineApi: string =
    environment.apiBaseUrl +
    "/api/v1/partner/vendor_orders/:order_id/update/stage_timeline/:batch_id";
  private createShipmentAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private invoiceStatsApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_order_invoices/stats";
  private invoiceListApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_order_invoices?search=";
  private postInvoicePaymentApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_order_invoices/";
  private downloadInvoiceApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private paymentRecieptApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private ewayBillApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private deliveryRecieptApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private invoiceDetailsAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private editAwbNumberApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private addDeliveryRecieptApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private downloadAllFilesApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private cavViewerAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/cleaned_models/";
  private companyLogoApi: string =
    environment.apiBaseUrl + "/api/v1/partner/update_company_logo";
  private directorAvatarAPi: string =
    environment.apiBaseUrl + "/api/v1/partner/update_proprietor_avatar";
  private userAvatarApi: string =
    environment.apiBaseUrl + "/api/v1/partner/update_user_avatar";
  private downloadBomApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private downloadQcReport: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private convertProjectDesign: string =
    environment.designUrl + "api/v1/orders/convert_order/";
  private ticketsApi: string = environment.customerUrl + "api/v1/ticket/";
  private addCommentsApi: string =
    environment.customerUrl + "api/v1/ticket/createTicketComment";

  private addPaintingApi: string =
    environment.apiBaseUrl + "/api/v1/partner/vendor_orders/";
  private customerOrderQuoteListApi: string =
    environment.customerUrl + "api/v1/ticket/getIds/customer-order";
  private partnerOrderQuoteListApi: string =
    environment.customerUrl + "api/v1/ticket/getIds/partner-order";

  private getSupplierOrderListApi: string =
    environment.apiBaseUrl + "/api/v1/procure/orders/getordersbysupplierid/";
  private getPartnerOrderListApi: string =
    environment.apiBaseUrl + "/api/v1/procure/orders/getordersbycustomerid/";
  private getQuotesListApi: string =
    environment.apiBaseUrl + "/api/v1/procure/quote/getquotebycustomerid/";
  private getQuoteBidApi: string =
    environment.apiBaseUrl + "/api/v1/procure/bid/get-bid-by-supplier/";
  private getOrdersListApi: string =
    environment.apiBaseUrl + "/api/v1/procure/orders/get-orders";
  private getBidDetailsApi: string =
    environment.apiBaseUrl + "/api/v1/procure/bid/get-bid-details/";
  private getQuoteDetailsApi: string =
    environment.apiBaseUrl + "/api/v1/procure/quote/getquotebyid/";
  private createQuoteApi: string =
    environment.apiBaseUrl + "/api/v1/procure/quote/create";
  private updateQuoteApi: string =
    environment.apiBaseUrl + "/api/v1/procure/quote/updatequote/";
  private updateBidItemsApi: string =
    environment.apiBaseUrl + "/api/v1/procure/bid/items-update/";
  private completeOrderApi: string =
    environment.apiBaseUrl + "/api/v1/procure/orders/complete/";
  private getLoanApi: string =
    environment.apiBaseUrl + "/api/v1/loan/authToken";
  private loanfiles: string = environment.apiBaseUrl + "/api/v1/loan/loanFiles";

  private getAllCostingTemplate: string =
    environment.apiBaseUrl + "/api/v1/partner/getallCostingTemplate";
  private uploadUrl: string = environment.apiBaseUrl + "/api/v1/partner/";
  private stagesApi: string =
    environment.apiBaseUrl +
    "/api/v1/partner/vendor_orders/vendor_order_item_batch_stages";
  private getInventoriesApi: string =
    environment.apiBaseUrl + "/api/v1/inventory";
  private getShipmentsApi: string =
    environment.apiBaseUrl + "/api/v1/shipments";
  private getInvoicesApi: string =
    environment.apiBaseUrl + "/api/v1/partner/invoice";
  private fileDownloadUrl: string =
    environment.apiBaseUrl + "/api/v1/fileservices/generate-singed-url";

  private getTermsApi: string = environment.apiBaseUrl + '/api/v1/partner/terms/get_terms';
  private getTermApi: string = environment.apiBaseUrl + '/api/v1/partner/terms/get_term';
  private createTermApi: string = environment.apiBaseUrl + '/api/v1/partner/terms/create_term';
  private updateTermApi: string = environment.apiBaseUrl + '/api/v1/partner/terms/update_term';
  private AdminNdaApi: string = environment.adminBaseUrl + "/v1/bid/";
  private createDefaultChannelApi: string = environment.engageApiUrl + 'channel/create.default.chat';
  options: any;
  headers: any;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private toastr: ToastrService
  ) {
    this.options = this.authService.getHeaders();
    this.headers = { headers: this.options, observe: "response" };
  }

  getPoDetails(id) {
    let url = environment.apiBaseUrl + "/api/v1/partner/vendor_orders/" + id;
    return this.http.get(url, this.options);
  }

  getOrderBatches(orderId: any) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/partner/vendor_orders/vendor_order_item_batch/vendor_order/" +
      orderId;
    return this.http.get(url, this.options);
  }

  getAllInspectionDetailsByOrderId(orderId: any) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/inspection/get_by_vendor_order/" +
      orderId;
    return this.http.get(url, this.options);
  }

  getAllInspectionDetails(pageNo: string, pageSize: string) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/inspection/get_all_records" +
      "?page_no=" +
      pageNo +
      "&offset=" +
      pageSize;
    return this.http.get(url, this.headers);
  }

  getInventoryDetailsByOrderId(orderId: any) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/inventory/get_by_vendor_order/" +
      orderId;
    return this.http.get(url, this.options);
  }

  sendInspectionRequest(orderId: any, body: any) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/inspection/send_inspection_invite/" +
      orderId;
    return this.http.post(url, body, this.options);
  }

  sendInspectionReminder(inspectionId: any, body: any) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/inspection/send_reminder/" +
      inspectionId;
    return this.http.post(url, body, this.options);
  }

  deleteInspection(inspectionId: any) {
    let url = environment.apiBaseUrl + "/api/v1/inspection/" + inspectionId;
    return this.http.delete(url, this.options);
  }

  getInspectionSessionRoles() {
    const url =
      environment.apiBaseUrl + "/api/v1/inspection/inspection_session_roles";
    return this.http.get(url, this.options);
  }

  getQualityControlParams(vendorOrderId: any) {
    const url =
      environment.apiBaseUrl +
      "/api/v1/inspection/quality_control_params/" +
      vendorOrderId;
    return this.http.get(url, this.options);
  }

  getInternationCode() {
    return this.http.get("./assets/phone_number/international_code.json");
  }

  viewPurchaseOrderPdf(vendorOrderId) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/partner/vendor_orders/" +
      vendorOrderId +
      "/view_po";
    return <any>this.http.get(url, this.options);
  }

  viewBOMPdf(vendorOrderId) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/partner/vendor_orders/" +
      vendorOrderId +
      "/view_bom";
    return <any>this.http.get(url, this.options);
  }

  viewPartModelFile(vendorOrderId, itemId) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/partner/vendor_orders/" +
      vendorOrderId +
      "/view_order_item_model_file?item_id=" +
      itemId;
    return <any>this.http.get(url, this.options);
  }

  downloadZipFile(vendorOrderId) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/partner/vendor_orders/" +
      vendorOrderId +
      "/download_all_files";
    return <any>this.http.get(url, this.options);
  }

  getCompanyDetails() {
    let url = environment.apiBaseUrl + "/api/v1/partner/view_profile_detail";
    return <any>this.http.get(url, this.options);
  }

  getCapabilityDetails() {
    let url = environment.apiBaseUrl + "/api/v1/partner/view_capability_detail";
    return <any>this.http.get(url, this.options);
  }

  getVendorOwnedMachines() {
    let url = environment.apiBaseUrl + "/api/v1/partner/vendor_owned_machines";
    return <any>this.http.get(url, this.options);
  }

  updateProfileDetails(formValue) {
    let url = environment.apiBaseUrl + "/api/v1/partner/update_user_details";
    return this.http.patch(url, formValue, this.options);
  }

  updateCompanyDetails(formValue) {
    let url = environment.apiBaseUrl + "/api/v1/partner/update_company_details";
    return this.http.patch(url, formValue, this.options);
  }

  sendOTP(param: any) {
    let url = environment.apiBaseUrl + "/generate_otp";
    return this.http.post(url, param, this.options);
  }

  submitOTP(param: any) {
    let url = environment.apiBaseUrl + "/verify_otp";
    return this.http.post(url, param, this.options);
  }

  getPrintProcesses() {
    let url = environment.apiBaseUrl + "/api/v1/print_processes";
    return this.http.get(url, this.options);
  }

  getCertificates() {
    let url = environment.apiBaseUrl + "/api/v1/certifications";
    return this.http.get(url, this.options);
  }

  getIndustries() {
    let url = environment.apiBaseUrl + "/api/v1/master_industries";
    return this.http.get(url, this.options);
  }

  getMasterSpecs() {
    let url = environment.apiBaseUrl + "/api/v1/master_specifications";
    return this.http.get(url, this.options);
  }

  getMachineUnits() {
    let url = environment.apiBaseUrl + "/api/v1/machine_specification_units";
    return this.http.get(url, this.options);
  }

  searchMachines(keyword) {
    let url =
      environment.apiBaseUrl + "/api/v1/search_machine_name?vm_name=" + keyword;
    return this.http.get(url, this.options);
  }

  getMachineRelatedSpecs(machineId) {
    let url =
      environment.apiBaseUrl +
      "/api/v1/vendor_machines/" +
      machineId +
      "/machine_specs";
    return this.http.get(url, this.options);
  }

  searchBrands(keyword) {
    let url =
      environment.apiBaseUrl + "/api/v1/search_brand_name?b_name=" + keyword;
    return this.http.get(url, this.options);
  }

  updatePrintProcessDetails(formValue) {
    let url = environment.apiBaseUrl + "/api/v1/partner/update_print_processes";
    return <any>this.http.patch(url, formValue, this.options);
  }

  updateMachineDetails(formValue) {
    let url = environment.apiBaseUrl + "/api/v1/partner/update_machine_details";
    return this.http.patch(url, formValue, this.options);
  }

  updateIndustriesDetails(formValue) {
    let url = environment.apiBaseUrl + "/api/v1/partner/update_industries";
    return <any>this.http.patch(url, formValue, this.options);
  }

  updateCertificationsDetails(formValue) {
    let url = environment.apiBaseUrl + "/api/v1/partner/update_certifications";
    return <any>this.http.patch(url, formValue, this.options);
  }

  updateUserPassword(formValue) {
    let url = environment.apiBaseUrl + "/api/v1/partner/update_password";
    return <any>this.http.patch(url, formValue, this.options);
  }

  // **********************************vendor-portal-new-branding-apis*******************************//

  getUserStatistics() {
    let url = this.userStatsApi;
    return this.http.get(url, this.headers);
  }

  getDashboardCharts(startDate, endDate, frequency:'year'|'month'|'date'|'week') {
    let url =
      this.dashboardChartsApi + `?startDate=${startDate}&endDate=${endDate}&frequency=${frequency}`;
    return this.http.get(url, this.headers);
  }

  getLiveEnquiriesList(page, search) {
    let url = this.liveEnquiriesApi + "?page=" + page + "&search=" + search;
    return this.http.get(url, this.headers);
  }

  getVendorBidDetails(obj) {
    let url = this.VendorBidDetailsApi + obj;
    return this.http.get(url, this.headers);
  }

  getPastEnquiriesList(page, search) {
    let url = this.pastEnquiriesApi + "?page=" + page + "&search=" + search;
    return this.http.get(url, this.headers);
  }

  getVendorItemDetails(enquiryId, itemId) {
    let url =
      this.vendorOrderItemApi + enquiryId + "/vendor_bid_items/" + itemId;
    return this.http.get(url, this.headers);
  }

  getVendorOrderItemDetails(orderId, itemId) {
    let url =
      this.vendorOrderItemApiOld + orderId + "/vendor_order_items/" + itemId;
    return this.http.get(url, this.headers);
  }

  updateVendorOrderItem(enquiryId, itemId, form) {
    let url =
      this.vendorOrderItemApi + enquiryId + "/vendor_bid_items/" + itemId;
    return this.http.put(url, form, this.headers);
  }

  updateVendorOrderItemCostingTemplated(bidSelectionId, partId, form) {
    let url =
      this.vendorOrderItemApi + bidSelectionId + "/vendor_bid_items_costing_templated/" + partId;
    return this.http.put(url, form, this.headers);
  }

  getVendorOrderItemCostingTemplated(bidSelectionId, partId) {
    let url =
      this.vendorOrderItemApi + bidSelectionId + "/vendor_bid_items_costing_templated/" + partId;
    return this.http.get(url, this.headers);
  }

  updateVendorOrderAgreementDetails(bidSelectionId, form) {
    let url =
      this.vendorOrderItemApi + bidSelectionId + "/vendor_bid_items_agreement_details";
    return this.http.put(url, form, this.headers);
  }

  getVendorOrderItemAgreementDetails(bidSelectionId) {
    let url =
      this.vendorOrderItemApi + bidSelectionId + "/vendor_bid_items_agreement_details";
    return this.http.get(url, this.headers);
  }

  getRejectReasonList() {
    let url = this.rejectReasonsListApi;
    return this.http.get(url, this.headers);
  }

  rejectLiveEnquiry(id, form) {
    let url = this.rejectLiveQuoteAPi + id + "/mark_as_rejected";
    return this.http.patch(url, form, this.headers);
  }

  rejectRevisedLiveEnquiry(id, form) {
    let url = this.rejectLiveQuoteAPi + id + "/mark_as_revision_rejected";
    return this.http.patch(url, form, this.headers);
  }

  acceptRevisedLiveEnquiry(id, form) {
    let url = this.rejectLiveQuoteAPi + id + "/mark_as_revision_accepted";
    return this.http.patch(url, form, this.headers);
  }

  updateQuoteCosting(id, form) {
    let url = this.updateRfqCostApi + id;
    return this.http.put(url, form, this.headers);
  }

  submitLiveEnquiry(id, body) {
    let data = {
      ...body
    };
    let url = this.submitLiveRfqApi + id + "/mark_as_quoted";
    return this.http.patch(url, data, this.headers);
  }

  getPendingPoList(page, search) {
    let url = this.pendingPoListAPi + "?page=" + page + "&search=" + search;
    return this.http.get(url, this.headers);
  }

  getActivePoList(page, search) {
    let url = this.activePoListAPi + "?page=" + page + "&search=" + search;
    return this.http.get(url, this.headers);
  }

  getPastPoList(page, search) {
    let url = this.pastPoListApi + "?page=" + page + "&search=" + search;
    return this.http.get(url, this.headers);
  }

  getPastRejectedPoList(page, search) {
    let url =
      this.pastPoListApi +
      "?page=" +
      page +
      "&search=" +
      search +
      "&status=" +
      "Rejected";
    return this.http.get(url, this.headers);
  }

  getPastCompletedPoList(page, search) {
    let url =
      this.pastPoListApi +
      "?page=" +
      page +
      "&search=" +
      search +
      "&status=" +
      "Completed";
    return this.http.get(url, this.headers);
  }

  getPurchaseOrderDetails(id) {
    let url = this.poDetailsApi + id + "/po_details";
    return this.http.get(url, this.headers);
  }

  acceptPurchaseOrder(id) {
    let url = this.acceptPoAPi + id + "/mark_as_accepted";
    return this.http.get(url, this.headers);
  }

  rejectPurchaseOrder(id, form) {
    let url = this.rejectPoApi + id + "/mark_as_rejected";
    return this.http.patch(url, form, this.headers);
  }

  getUserProfileDetails() {
    let url = this.userProfileApi;
    return this.http.get(url, this.options);
  }

  getVendorMachineList() {
    let url = this.machineListApi;
    return this.http.get(url, this.options);
  }

  getVendorCapabilityDetails() {
    let url = this.capabilitiesAPi;
    return this.http.get(url, this.options);
  }

  updatePassword(form) {
    let url = this.updatePasswordApi;
    return this.http.post(url, form, this.options);
  }

  getUserBankDetails() {
    let url = this.bankDetailsApi;
    return this.http.get(url, this.options);
  }

  updateBankDetails(form) {
    let url = this.updateBankDetailsApi;
    return this.http.patch(url, form, this.options);
  }

  updateTermsConditions(form) {
    let url = this.updateTermsApi;
    return this.http.patch(url, form, this.options);
  }

  raiseRequestProfileUpdate(form) {
    let url = this.raiseRequestApi;
    return this.http.patch(url, form, this.options);
  }

  getInventoryList(id) {
    let url = this.inventoryListApi + id + "/show_inventory_items";
    return this.http.get(url, this.headers);
  }

  createDispatchBatch(orderId, itemId, form) {
    let url =
      this.createDispatchAPi +
      orderId +
      "/vendor_order_items/" +
      itemId +
      "/add_dispatch_batch";
    return this.http.patch(url, form, this.headers);
  }

  createDispatchBatchForOrderBatch(orderId, bidItemId, batchId, form) {
    let url =
      this.createDispatchAPi +
      orderId +
      "/vendor_order_items/" +
      bidItemId +
      "/order_item_batch/" +
      batchId +
      "/add_dispatch_batch";
    return this.http.patch(url, form, this.headers);
  }

  fetchVendorOrderItemBatch(batchId) {
    let url = this.updateBatchAPi + batchId;
    return this.http.get(url, this.headers);
  }

  updateBatchTimeline(orderId, batchId, body) {
    let url = this.updateBatchTimelineApi
      .replace(":order_id", orderId)
      .replace(":batch_id", batchId);
    return this.http.post(url, body, this.headers);
  }

  fetchAllBatchStages() {
    const url = this.stagesApi;
    return this.http.get(url, this.headers);
  }

  updateVendorOrderItemBatch(batchId, form) {
    let url = this.updateBatchAPi + batchId;
    return this.http.post(url, form, this.headers);
  }

  createShipmentOrder(orderId, form) {
    let url = this.createShipmentAPi + orderId + "/vendor_shipments";
    return this.http.post(url, form, this.options);
  }

  getInvoiceStatistics() {
    let url = this.invoiceStatsApi;
    return this.http.get(url, this.options);
  }

  getInvoiceList(string, start_date, end_date) {
    let url =
      this.invoiceListApi +
      string +
      "&start_date=" +
      start_date +
      "&end_date=" +
      end_date;
    return this.http.get(url, this.options);
  }

  createInvoicePayment(id, form) {
    let url =
      this.postInvoicePaymentApi + id + "/vendor_order_invoice_payments";
    return this.http.post(url, form, this.options);
  }

  downloadVendorInvoice(order_id, invoice_id) {
    let url =
      this.downloadInvoiceApi +
      order_id +
      "/vendor_order_invoices/" +
      invoice_id +
      "/download_invoice";
    return this.http.get(url, this.options);
  }

  downloadPaymentReciept(order_id, invoice_id) {
    let url =
      this.paymentRecieptApi +
      order_id +
      "/vendor_order_invoices/" +
      invoice_id +
      "/download_payment_receipts";
    return this.http.get(url, this.options);
  }

  downloadEWayBill(order_id, invoice_id) {
    let url =
      this.ewayBillApi +
      order_id +
      "/vendor_order_invoices/" +
      invoice_id +
      "/download_eway_bill";
    return this.http.get(url, this.options);
  }

  downloadDeliveryReciept(order_id, invoice_id) {
    let url =
      this.deliveryRecieptApi +
      order_id +
      "/vendor_order_invoices/" +
      invoice_id +
      "/download_delivery_receipts";
    return this.http.get(url, this.options);
  }

  getShipmentInvoiceDetails(order_id) {
    let url = this.invoiceDetailsAPi + order_id + "/get_shipments_and_invoices";
    return this.http.get(url, this.options);
  }

  editAwbNumber(order_id, shipment_id, form) {
    let url =
      this.editAwbNumberApi + order_id + "/vendor_shipments/" + shipment_id;
    return this.http.patch(url, form, this.options);
  }

  addDeliveryReceipt(order_id, invoice_id, formData) {
    let url =
      this.addDeliveryRecieptApi +
      order_id +
      "/vendor_order_invoices/" +
      invoice_id +
      "/add_delivery_receipt";
    return this.http.patch(url, formData, this.options);
  }

  downloadAllFiles(order_id) {
    let url = this.downloadAllFilesApi + order_id + "/download_all_files";
    return this.http.get(url, this.options);
  }

  uploadCompanyLogo(form) {
    let url = this.companyLogoApi;
    return this.http.patch(url, form, this.options);
  }

  uploadProprietorAvatar(form) {
    let url = this.directorAvatarAPi;
    return this.http.patch(url, form, this.options);
  }

  uploadUserAvatar(form) {
    let url = this.userAvatarApi;
    return this.http.patch(url, form, this.options);
  }

  downloadBom(id) {
    let url = this.downloadBomApi + id + "/view_bom";
    return this.http.get(url, this.options).subscribe(
      (res: any) => {
        if (res.url == null) {
          return this.toastr.info(
            "There is no BOM available to download",
            "Info"
          );
        } else {
          window.open(res.url, "_blank");
          this.toastr.success("BOM downloaded", "Success");
        }
      },
      (err) => {
        this.toastr.error("BOM cannot be downloaded", "Error");
      }
    );
  }

  // truventor-calculate-method

  getCadViewerFile(id):Observable<any> {
    let url = this.cavViewerAPi + id + "/get_cad_viewer";
    return this.http.get(url, this.options);
  }

  navigateToCalculate(id) {
    let cleaned_model_id = id;
    let cad_viewer_url;
    this.getCadViewerFile(cleaned_model_id).subscribe(
      (res: any) => {
        let parts = res.file_name.split(".");
        let ext = parts[parts.length - 1].toLowerCase();
        let type = "3D";
        if (ext === "dxf") {
          type = "2D";
        }
        cad_viewer_url = res.cad_viewer_file_url;
        const viewer_url = encodeURIComponent(cad_viewer_url);
        window.open(
          environment.cadViewerBase +
            "viewer/?type=" +
            type +
            "&url=" +
            viewer_url +
            "&auth=" +
            localStorage.getItem("token"),
          "_blank"
        );
      },
      (err) => {
        console.log(err);
      }
    );
  }

  openInCalcuateService(object) {
    let url = this.convertProjectDesign;
    return this.http.post(url, object);
  }

  // *********************international-code-with-flag********************************//

  getInternationalCode() {
    return this.http.get("./assets/phone_number/international_code.json");
  }

  downloadQcReports(order_id) {
    let url = this.downloadQcReport + order_id + "/downloadQcReports";
    return this.http.get(url);
  }

  getTicketsList(id, pageNo, perpage, Status, category) {
    let url =
      this.ticketsApi +
      "?size=" +
      perpage +
      "&page=" +
      pageNo +
      "&id=" +
      id +
      "&status=" +
      Status +
      "&category=" +
      category;
    return this.http.get(url);
  }

  deleteTicket(id) {
    let url = this.ticketsApi + id + "/deleteticket";
    return this.http.patch(url, {});
  }

  getSelectedTicketData(id) {
    let url = this.ticketsApi + id;
    return this.http.get(url);
  }

  getTicketsComment(id) {
    let url = this.ticketsApi + id + "/getTicketComment";
    return this.http.get(url);
  }

  addComments(reqobj) {
    let url = this.addCommentsApi;
    return this.http.post(url, reqobj);
  }
  addPainting(order_id, itemId, formData) {
    let url =
      this.addPaintingApi +
      order_id +
      "/vendor_order_items/" +
      itemId +
      "/add_painting";
    return this.http.patch(url, formData, this.options);
  }
  addQualityCheck(order_id, itemId, formData) {
    let url =
      this.addPaintingApi +
      order_id +
      "/vendor_order_items/" +
      itemId +
      "/add_quality_check";
    return this.http.patch(url, formData, this.options);
  }
  downloadFile(order_id, file_name) {
    let url =
      this.addPaintingApi +
      order_id +
      "/vendor_order_items/download_painting/" +
      file_name;
    return this.http.get(url);
  }
  downloadQualityCheckFile(order_id, file_name) {
    let url =
      this.addPaintingApi +
      order_id +
      "/vendor_order_items/download_qualitycheck/" +
      file_name;
    return this.http.get(url);
  }

  getCustomerOrderQuoteNoList(pageNo) {
    let url = this.customerOrderQuoteListApi + "?size=10" + "&page=" + pageNo;
    return this.http.get(url);
  }

  getPartnerOrderQuoteNoList(pageNo) {
    let url = this.partnerOrderQuoteListApi + "?size=20" + "&page=" + pageNo;
    return this.http.get(url);
  }

  getNotificationDetails(pageCount, pageSize) {
    return this.http.get(
      environment.apiBaseUrl +
        "/api/v1/partner/notifications/list/" +
        "?size=" +
        pageSize +
        "&page=" +
        pageCount
    );
  }

  getQuotesList(userId) {
    let url = this.getQuotesListApi + userId;
    return this.http.get(url, this.headers);
  }

  getQuotesBidList(userId) {
    let url = this.getQuoteBidApi + userId;
    return this.http.get(url, this.headers);
  }

  getOrdersList() {
    let url = this.getOrdersListApi;
    return this.http.get(url, this.headers);
  }

  createQuotes(form) {
    let url = this.createQuoteApi;
    return this.http.post(url, form, this.options);
  }

  getQuoteDetails(id) {
    let url = this.getQuoteDetailsApi;
    return this.http.get(url + id, this.headers);
  }

  getSupplierOrderList(id) {
    let url = this.getSupplierOrderListApi;
    return this.http.get(url + id, this.headers);
  }

  getPartnerOrderList(id) {
    let url = this.getPartnerOrderListApi;
    return this.http.get(url + id, this.headers);
  }

  getBidDetails(id, quoteid) {
    let url = this.getBidDetailsApi + id + "/" + quoteid;
    return this.http.get(url, this.headers);
  }

  updateQuotes(id, form) {
    let url = this.updateQuoteApi + id;
    return this.http.patch(url, form, this.headers);
  }

  updateBidItems(id, quoteid, form) {
    let url = this.updateBidItemsApi + id + "/" + quoteid;
    return this.http.patch(url, form, this.headers);
  }

  completeOrder(id) {
    let url = this.completeOrderApi + id;
    return this.http.post(url, this.headers);
  }

  getCostingTemplateDownload() {
    let url = this.getAllCostingTemplate;
    return this.http.get(url, this.headers);
  }

  uploadFiles(id, data) {
    let url = this.uploadUrl + id + "/upload_costing";
    return this.http.post(url, data, this.headers);
  }

  loan(data) {
    let url = this.getLoanApi;
    return this.http.post(url, data, this.options);
  }

  addloanfiles(data: any) {
    let url = this.loanfiles;
    return this.http.post(url, data, this.headers);
  }

  getInventories(pageNo: string, pageSize: string) {
    const url =
      this.getInventoriesApi + "?page_no=" + pageNo + "&offset=" + pageSize;
    return this.http.get(url, { observe: "response" });
  }

  getShipments(pageNo: string, pageSize: string) {
    const url =
      this.getShipmentsApi + "?page_no=" + pageNo + "&offset=" + pageSize;
    return this.http.get(url, { observe: "response" });
  }

  getInventoryByOrderId(order_id: string) {
    const url = this.getInventoriesApi + "/order_id/" + order_id;
    return this.http.get(url);
  }

  getShipmentByIds(shipmentIds: number[]) {
    const url = this.getShipmentsApi + "/get_shipments_by_ids";
    return this.http.post(url, { ids: shipmentIds });
  }

  getInvoices(pageNo: string, pageSize: string, isActive: boolean) {
    const url =
      this.getInvoicesApi +
      "?status=" +
      (isActive ? "active" : "past") +
      "&page_no=" +
      pageNo +
      "&offset=" +
      pageSize;
    return this.http.get(url, { observe: "response" });
  }

  getInvoiceByOrderId(orderId: string) {
    const url = this.getInvoicesApi + "/" + orderId;
    return this.http.get(url);
  }

  async getPreSignedURL(fileName: string): Promise<any> {
    fileName = fileName.split("?X-Amz-Algorithm")[0];
    let temp = fileName.split(".com/");
    const result = await this.getSingedUrlFromApi(
      temp[temp.length - 1]
    ).toPromise();
    return result;
  }

  getSingedUrlFromApi(filename: string): Observable<any> {
    return this.http.post(this.fileDownloadUrl, { filename }).pipe(
      map((result) => {
        return result;
      })
    );
  }

  // Method to get all terms and conditions for a vendorBidId
  getTermsByVendorBidId(
    vendorBidId: string | number,
    bidSelectionId: string | number = ""
  ): Observable<any> {
    let url = `${this.getTermsApi}/${vendorBidId}`;
    if (bidSelectionId)
      url = `${this.getTermsApi}/${vendorBidId}/${bidSelectionId}`;
    return this.http.get(url);
  }

  // Method to get a specific term and condition by ID
  getTermById(id: string): Observable<any> {
    const url = `${this.getTermApi}/${id}`;
    return this.http.get(url);
  }

  // Method to create a new term and condition
  createTerm(termData: any): Observable<any> {
    return this.http.post(this.createTermApi, termData);
  }

  // Method to update a term and condition by ID
  updateTerm(id: string, termData: any): Observable<any> {
    const url = `${this.updateTermApi}/${id}`;
    return this.http.put(url, termData);
  }

  rejectNda(bidId:number, agreementId:number) {
    let url = `${this.AdminNdaApi}${bidId}/reject_nda/${agreementId}`;
    return this.http.get(url, this.headers);
  }

  acceptNda(bidId:number, agreementId:number) {
    let url = `${this.AdminNdaApi}${bidId}/accept_nda/${agreementId}`;
    return this.http.get(url, this.headers);
  }

  createDefaultChat() {
    const url = this.createDefaultChannelApi;
    return this.http.get(url);
  }
}
